import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { environment } from '@base/environments/environment'
import { Constants } from '@base/src/app/models/constants'
import { QRButton } from '@base/src/app/models/qr-button.model'
import { Reservation } from '@base/src/app/pages/stats/reservometro/models/reservation.model'
import { UtilsService } from '@base/src/app/services/utils.service'
import { ReservometroStatisticsService } from '../../../services/reservometro-statistics.service'

@Component({
  selector: 'app-dialog-preview-reservation',
  templateUrl: './dialog-preview-reservation.component.html',
  styleUrls: ['./dialog-preview-reservation.component.scss']
})
export class DialogPreviewReservationComponent implements OnInit {
  @Input() reservation!: Reservation
  @Output() close: EventEmitter<void> = new EventEmitter<void>()
  @Output() generateCl: EventEmitter<Reservation> =
    new EventEmitter<Reservation>()

  NODE_DO = Constants.TENANT_ID_DO
  NODE_EC = Constants.TENANT_ID_EC
  NODE = environment.node

  customerOriginPurchase: string = ''
  customerOriginSale: string = ''

  buttonGoBack: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Volver'
  }

  constructor (
    public utils: UtilsService,
    private readonly getDetailService: ReservometroStatisticsService
  ) {}

  ngOnInit (): void {
    this.getReservationDetail()
  }

  getReservationDetail (): void {
    const URL_RESERVATION_DETAIL: string = `reservation/${this.reservation.id}`
    this.getDetailService.get(URL_RESERVATION_DETAIL).then(response => {
      this.customerOriginPurchase = response.customerOriginPurchase ?? '-'
      this.customerOriginSale = response.customerOriginSale ?? '-'
    })
  }

  closeDialog (): void {
    this.close.emit()
  }

  generateClose (): void {
    this.generateCl.emit(this.reservation)
  }

  get currencySymbol (): string {
    return this.reservation.currency === 'USD' ? 'U$S' : '$'
  }
}
